import { validateSelectedListId } from '../utils/formValidationHelpers';
import { ContactListFilterItem } from './ContactListFilterItem';

export interface ListContact {
    leadId: number;
    clientId: string | null;
    firstName: string;
    lastName: string;
    name: string | null /* often null; use combined firstname, lastname instead */;
    phone: string | null;
    hasPhone: boolean /* true if phone field has value */;
    email: string | null;
    hasEmail: boolean /* true if email field has value */;
    statusId: number | null;
    statusName: string | null;
}

export interface ListContactsRequest {
    listId?: number;
    filters: ContactListFilterItem[];
    contactIds: number[];
}

/**
 * buildGetListContacts
 *
 * @description
 * Builds an object matching that expected by the server for a request to
 * get contacts contained within a list.
 */
export function buildGetListContacts(args: {
    /*
        validateListId is just a flag to trigger validation, will not be part of
        the resulting object
     */
    validateListId?: boolean;
    listId?: number;
    filters?: ContactListFilterItem[];
    contactIds?: number[];
}): ListContactsRequest {
    return {
        listId: args.validateListId
            ? validateSelectedListId('listId', args.listId as number)
            : args.listId,
        filters: args.filters || [],
        contactIds: args.contactIds || [],
    };
}
